<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-layout row wrap xs12 sm12 md12 lg12 ml-2 mr-2 row--dense>

        <!--上一周 下一周 UI-->
        <v-flex   class=" xs12 sm12 md7 ml-0 mt-1"> <!--row wrap justify-space-around style="height: 50px"-->
            <!--<v-flex xs12 sm12 md12 text-center row&#45;&#45;dense>-->
                <!--[{{zoneName}}]-->
            <!--</v-flex>-->
            <v-flex  xs12 sm12 md12 fontMiddle row--dense  :style="{textAlign:$vuetify.breakpoint.smAndDown?'center':'right'}">
                <v-btn  @click="lastWeek" middle class="pl-1 pr-1 mr-2 regFRBtn">
                    上一週
                </v-btn>
                <v-btn @click="thisWeek" middle class="pr-1 pl-1 mr-2 regFRBtn">
                    回本週
                </v-btn>
                <!--<input class="mr-2" @change="searchWeek" style="border:1px solid black" id="inputDate" type="date" >-->
                <v-btn  middle class="pl-1 pr-1 mr-2 regFRBtn" @click="pickDate = true">選擇日期</v-btn>

                <v-dialog
                        ref="dialog"
                        v-model="pickDate"
                        :return-value.sync="inputDate"
                        persistent
                        width="290px"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                                style="display: none"
                                v-model="inputDate"
                                label="Picker in dialog"
                                prepend-icon="event"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker v-model="inputDate" scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="pickDate = false">取消</v-btn>
                        <v-btn text color="primary" @click="confirmDate">確定</v-btn>
                    </v-date-picker>
                </v-dialog>

                <v-btn @click="nextWeek" middle class="pr-1 pl-1 mr-2 regFRBtn">
                    下一週
                </v-btn>

            </v-flex>


            <v-flex  xs12 sm12 md12 >
                <span class="fontMiddle">[{{zoneName}}] 今天日期: <span :style='this.$store.state.AppSetting.hospId=="weihao"?"color: #BC1D21;font-weight:800":"color: hotpink"'>{{this.$UtilityJs.AD2ROC_Date(new Date().toISOString())}}</span> </span>
            </v-flex>

            <v-flex  xs12 sm12 md12 >
                <span class="fontMiddle">查詢期間: <span :style='this.$store.state.AppSetting.hospId=="weihao"?"color: #BC1D21;font-weight:800":"color: hotpink"'>{{startRange}}</span> </span>
                <span class="fontMiddle"> 至 <span :style='this.$store.state.AppSetting.hospId=="weihao"?"color: #BC1D21;font-weight:800":"color: hotpink"'> {{endRange}}</span> </span>
            </v-flex>


            <v-row justify="space-around" row wrap>
                <v-col cols="12" sm="12" md="12" class="text-center">
                    <!--<v-sheet elevation="10" class="py-4 px-1">-->
                        <v-chip-group

                                v-model="chipGroup"
                                show-arrows
                                mandatory
                                active-class="black--text"
                        >

                            <v-col >
                                <v-btn :color="item.index==chipGroup?'secondary':'white'" :class="['chipItem',item.index==chipGroup?'chipClick':'']" style="font-size: 1.1rem"  v-for="(item, i) in clinicHeaders" :key="i" v-html="item.text" @click="setFilterDate(item)">
                                </v-btn>
                            </v-col>




                        </v-chip-group>
                    <!--</v-sheet>-->
                </v-col>
            </v-row>


            <v-flex  class="xs12 sm12 md12 row wrap ml-0">

            <clinic-table-no-head :date-index="chipGroup" :go-where="goWhere"  :clinic-data="clinicData1" :clinic-headers="header1" :loading="loading"></clinic-table-no-head>
            <clinic-table-no-head :date-index="chipGroup" :go-where="goWhere"  :clinic-data="clinicData2" :clinic-headers="header2" :loading="loading"></clinic-table-no-head>
            <clinic-table-no-head :date-index="chipGroup" :go-where="goWhere"  :clinic-data="clinicData3" :clinic-headers="header3" :loading="loading"></clinic-table-no-head>


            </v-flex>

        </v-flex>

        <v-flex :class="['xs12 sm12 md5 mt-1',$vuetify.breakpoint.smAndDown?'pl-1':'pl-7 pr-5']">
            <p v-html="regNote"></p>

        </v-flex>



    </v-layout>

</template>

<script>
    import ClinicTableNoHead from './ClinicTableNoHead'
    export default {
        name: "ClinicD",
        components:{ClinicTableNoHead},
        data() {
            return {
                zoneName:'',
                pickDate:false,
                inputDate:'',
                header1:[{text:'早診'}],
                header2:[{text:'午診'}],
                header3:[{text:'晚診'}],
                chipGroup:0,
                goWhere:'tan',
                tableTitle1:'上午 8:30 - 12:00',
                tableTitle2:'下午 14:00 - 17:30',
                tableTitle3:'晚上 18:00 - 21:30',
                startRange:'',
                endRange:'',
                clinicData: [],
                loading:false,
                loadingText:'查詢中...',
                clinicData1:[],
                clinicData2:[],
                clinicData3:[],
                clinicHeaders:[
                    {
                        index:0,
                        text: '星期一',
                        value: 'viewItemName1',
                    },
                    {
                        index:1,
                        text: '星期二',
                        value: 'viewItemName2',
                    },
                    {
                        index:2,
                        text: '星期三',
                        value: 'viewItemName3',
                    },
                    {
                        index:3,
                        text: '星期四',
                        value: 'viewItemName4',
                    },
                    {
                        index:4,
                        text: '星期五',
                        value: 'viewItemName5',
                    },
                    {
                        index:5,
                        text: '星期六',
                        value: 'viewItemName6',
                    },
                    {
                        index:6,
                        text: '星期日',
                        value: 'viewItemName7',
                    },
                ],
                startDate:'',
                endDate:'',
                regNote:'',
            }
        },
        created(){
            let today = this.$UtilityJs.AD2ROC_DateTime(new Date().toISOString(),'date');
            this.startDate = today;
            this.startDate = this.getStartDate();
            this.endDate = this.getEndDate();
            this.axios_getClinicData();
            let divCode = this.$route.params.divCode==undefined?'ALL':this.$route.params.divCode;
            let empNo = this.$route.query.empNo==undefined?'':this.$route.query.empNo;
            this.axios_getRegNote(divCode+','+empNo);
            this.getWhichDay('today'); //設定預設今天星期 1100208
            this.axios_getZoneName();
        },
        watch: {
            '$route.params': function () {
                this.axios_getClinicData();
                let divCode = this.$route.params.divCode==undefined?'ALL':this.$route.params.divCode;
                let empNo = this.$route.query.empNo==undefined?'':this.$route.query.empNo;
                this.axios_getRegNote(divCode+','+empNo);
                this.axios_getZoneName();
            },
        },
        methods:{
            getWhichDay(flag){ //設定預設今天星期
                let nowDate = new Date();
                let nowDay;
                if(flag=='today'){
                    nowDay = nowDate.getDay();
                }else { //系統依user選擇的日期 切換 chipGroup的值 110/06/24 by IvyLin
                    nowDay = flag.getDay();
                }
                switch (nowDay)
                {
                    case 0:
                        this.chipGroup = 6; //星期日
                        break;
                    case 1:
                        this.chipGroup = 0; //星期一
                        break;
                    case 2:
                        this.chipGroup = 1; // 星期二;
                        break;
                    case 3:
                        this.chipGroup = 2; //星期三;
                        break;
                    case 4:
                        this.chipGroup = 3; //星期四;
                        break;
                    case 5:
                        this.chipGroup = 4; //星期五;
                        break;
                    case 6:
                        this.chipGroup = 5; // 星期六;
                        break;
                }
            },
            confirmDate(){
                this.$refs.dialog.save(this.inputDate);
                this.searchWeek();
            },
            setHeader(data){
                return data.filter((i) => {
                   return i.clinicNo== 9999;
                })
            },
            setNotHeader(data){
                return data.filter((i) => {
                    return i.clinicNo!== 9999;
                })
            },
            setFilterDate(item){
            this.chipGroup = item.index;
            },
            thisWeek(){
                let today = this.$UtilityJs.AD2ROC_DateTime(new Date().toISOString(),'date');
                this.startDate = today;
                this.startDate = this.getStartDate();
                this.endDate = this.getEndDate();
                this.axios_getClinicData();
            },
            lastWeek(){
                this.startDate = this.getLastWeek(this.startDate);
                this.endDate= this.getEndDate();
                this.axios_getClinicData();
            },
            nextWeek(){
                this.startDate = this.getNextWeek(this.startDate);
                this.endDate = this.getEndDate();
                this.axios_getClinicData();
            },
            getStartDate(){ //取得當下日期 當周 星期一
                // let startDate = new Date(this.startDate+" 00:00:00")
                let sDate = this.startDate.replace(new RegExp("-","gm"),"");
                let y = sDate.substring(0,4);
                let m = sDate.substring(4,6);
                let d = sDate.substring(6,8)
                let startDate = new Date(parseInt(y), parseInt(m)-1, parseInt(d), 0, 0, 0, 0);

                if(startDate.getDay() == 0)
                {
                    startDate.setDate(startDate.getDate() - 6);
                }
                else
                {
                    startDate.setDate(startDate.getDate() - (startDate.getDay()-1));
                }
                return this.$UtilityJs.AD2ROC_DateTime(startDate.toISOString(),'date');

            },
            getEndDate(){ //取得當下日期 當周 星期日
                // let endDate = new Date(this.startDate);
                // let endDate = new Date(this.startDate+" 00:00:00");
                let eDate = this.startDate.replace(new RegExp("-","gm"),"");
                let y = eDate.substring(0,4);
                let m = eDate.substring(4,6);
                let d = eDate.substring(6,8)
                let endDate = new Date(parseInt(y), parseInt(m)-1, parseInt(d), 0, 0, 0, 0);

                if(endDate.getDay() != 0)
                {
                    endDate.setDate(endDate.getDate() + (7-endDate.getDay()));
                }
                return this.$UtilityJs.AD2ROC_DateTime(endDate.toISOString(),'date');
            },
            getNextWeek(start){ //取得下一周
                // let endDate = new Date(start+" 00:00:00");
                let eDate = start.replace(new RegExp("-","gm"),"");
                let y = eDate.substring(0,4);
                let m = eDate.substring(4,6);
                let d = eDate.substring(6,8)
                let endDate = new Date(parseInt(y), parseInt(m)-1, parseInt(d), 0, 0, 0, 0);

                if(endDate.getDay() != 0)
                {
                    endDate.setDate(endDate.getDate() + (8-endDate.getDay()));
                }
                return this.$UtilityJs.AD2ROC_DateTime(endDate.toISOString(),'date');
            },
            getLastWeek(start){ //取得上一周
                // let endDate = new Date(start+" 00:00:00");
                let eDate = start.replace(new RegExp("-","gm"),"");
                let y = eDate.substring(0,4);
                let m = eDate.substring(4,6);
                let d = eDate.substring(6,8)
                let endDate = new Date(parseInt(y), parseInt(m)-1, parseInt(d), 0, 0, 0, 0);

                if(endDate.getDay() != 0)
                {
                    endDate.setDate(endDate.getDate() - (8-endDate.getDay()));
                }
                return this.$UtilityJs.AD2ROC_DateTime(endDate.toISOString(),'date');
            },

            searchWeek(){
                this.startDate = this.inputDate;
                this.startDate = this.getStartDate();
                this.endDate = this.getEndDate();
                this.axios_getClinicData('choose');
            },
            setHeaders(data){
                this.clinicHeaders = [];
                this.clinicHeaders.push(
                    {
                        index:0,
                        text: data[0].clinicTable[0].viewItemName1+'<br/>'+data[0].clinicTable[0].viewItemUrl1,
                        value: 'viewItemName1',
                    },
                    {
                        index:1,
                        text: data[0].clinicTable[0].viewItemName2+'<br/>'+data[0].clinicTable[0].viewItemUrl2,
                        value: 'viewItemName2',
                    },
                    {
                        index:2,
                        text: data[0].clinicTable[0].viewItemName3+'<br/>'+data[0].clinicTable[0].viewItemUrl3,
                        value: 'viewItemName3',
                    },
                    {
                        index:3,
                        text: data[0].clinicTable[0].viewItemName4+'<br/>'+data[0].clinicTable[0].viewItemUrl4,
                        value: 'viewItemName4',
                    },
                    {
                        index:4,
                        text: data[0].clinicTable[0].viewItemName5+'<br/>'+data[0].clinicTable[0].viewItemUrl5,
                        value: 'viewItemName5',
                    },
                    {
                        index:5,
                        text: data[0].clinicTable[0].viewItemName6+'<br/>'+data[0].clinicTable[0].viewItemUrl6,
                        value: 'viewItemName6',
                    },
                    {
                        index:6,
                        text: data[0].clinicTable[0].viewItemName7+'<br/>'+data[0].clinicTable[0].viewItemUrl7,
                        value: 'viewItemName7',
                    },
                )
            },

            filterClinicData(arrayList,apn){
                let data = [];
                arrayList.filter(function (item,i) {
                    item.clinicTable.filter(function (subItem,index,array) {

                        if(index==apn){
                            data.push(array[index]);
                            data[i].clinicName = item.clinicName;
                            data[i].clinicNo = item.clinicNo;
                        }
                    })

                })
                return data;
            },
            axios_getClinicData (flag){ //門診清單
                this.loading = true;
                let url = '';
                let start = this.startDate.replace(new RegExp("-","gm"),"");
                let end =   this.endDate.replace(new RegExp("-","gm"),"");
                start = parseInt(start.substring(0,4))-1911+""+start.substring(4,8)
                end = parseInt(end.substring(0,4))-1911+""+end.substring(4,8)

                this.startRange = this.$UtilityJs.AD2ROC_Date(this.startDate);
                this.endRange = this.$UtilityJs.AD2ROC_Date(this.endDate);

                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                let divCode = this.$route.params.divCode==undefined?'ALL':this.$route.params.divCode;
                let empNo = this.$route.query.empNo==undefined?'ALL':this.$route.query.empNo;
                url = this.$store.state.AppSetting.backSrvUrl + "clinicparam/clinictable/"+zone+"/"+start+"/"+end+"/"+divCode+"/"+empNo;

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.clinicData = response.data.resultSet;

                        if(response.data.resultSet.length==1){
                            console.error("url="+url);
                            console.error("回傳長度="+response.data.resultSet.length);
                            console.error(response.data.resultSet)
                        }
                        let header = this.setHeader(this.clinicData);
                        this.setHeaders(header);
                        this.loading = false;
                        let noHeaderArray =  this.setNotHeader(this.clinicData);
                        this.clinicData1 = this.filterClinicData(noHeaderArray,0);
                        this.clinicData2 = this.filterClinicData(noHeaderArray,1);
                        this.clinicData3 = this.filterClinicData(noHeaderArray,2);
                        if(flag=='choose'){
                            this.getWhichDay(new Date(this.inputDate));//系統依user選擇的日期 切換 chipGroup的值 110/06/24 by IvyLin
                        }


                    }else{
                        this.clinicData = [];
                        this.clinicData1 = [];
                        this.clinicData2 = [];
                        this.clinicData3 = [];
                        this.loading = false;
                    }
                }).catch(error =>  {

                    try {
                        this.clinicData = [];
                        this.clinicData1 = [];
                        this.clinicData2 = [];
                        this.clinicData3 = [];
                        this.loading = false;
                        console.log(error.response.data.status);

                    } catch(err) {
                        this.clinicData = [];
                        this.clinicData1 = [];
                        this.clinicData2 = [];
                        this.clinicData3 = [];
                        this.loading = false;
                    }

                });
            },
            axios_getRegNote (codeNo){ //掛號說明
                this.regNote = '';
                let url = '';
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                url = this.$store.state.AppSetting.backSrvUrl + "regnote/datasearch/primarykeys/"+zone+"/CLINIC/"+codeNo;

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        for(let i in response.data.resultSet){
                            if(response.data.resultSet[i].regNote!==undefined&&response.data.resultSet[i].regNote!==''){
                                this.regNote+=response.data.resultSet[i].regNote+"<br/>"
                            }
                        }
                    }else{
                        this.regNote = '';
                    }


                }).catch(error =>  {
                    try {
                        console.log(error.response.data.status);
                        this.regNote = '';
                    } catch(err) {
                        this.regNote = '';
                    }
                });


            },
            axios_getZoneName (){  //查詢院區名稱
                this.zoneName = '';
                let url = '';
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                url = this.$store.state.AppSetting.backSrvUrl + "zoneset/datasearch/primarykeys/"+zone;
                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.zoneName = response.data.resultSet[0].zoneName;
                    }else{
                        this.zoneName ='';
                    }
                }).catch(error =>  {
                    this.zoneName = '';
                    try {
                        console.log(error.response.data.status);

                    } catch(err) {
                        console.log(err.toString())
                    }
                });
            },
        }
    }
</script>

<style scoped>

    .chipItem{
        margin: 0px 0px 0px 0;
        border-radius: 5px!important;
        height: auto!important;
        padding: 2px!important;
        /*border-color: rgba(0, 0, 0, 0.12);*/
        cursor: pointer;
        /*background: #FAB440;*/
        border: 0.1px solid rgba(0, 0, 0, 0.12);
        width: 14.4%;
        text-align: center;
    }

    .chipClick{
        /*color: var(--v-primary-base) !important;*/
        color: #fff;
        caret-color: var(--v-primary-base) !important;
        background: #FAB440!important;
    }

</style>